import * as React from "react";
import { LiveOutright, MiniOutright, AggregateCard } from "../../../components";
import * as MiniCardTypes from "../../../components/MiniEventCardTypes";
import * as CardTypes from "../../../components/EventCardTypes";
import { RenderPreliveOutright } from "../../../components/RenderComponents/RenderPreliveOutright";
import { CardProps } from "../../../../../typings/CardProps";

export class RenderCard extends React.PureComponent<CardProps, {}> {
    getCardType() {
        const ComponentTypeMap = {
            AggregateCard,
            CardTypes,
            MiniCardTypes,
            MiniOutright,
            LiveOutright,
            PreLiveOutright: RenderPreliveOutright
        }

        return this.props.event.cardType
            ? ComponentTypeMap[this.props.event.componentType][this.props.event.cardType]
            : ComponentTypeMap[this.props.event.componentType];
    }

    render() {
        let CardTypeComp = this.getCardType();
        return <CardTypeComp {...this.props} />
    }
}